import enTranslations from '@/assets/locales/en.json'; // English
import ruTranslations from '@/assets/locales/ru.json'; // Russian
import plTranslations from '@/assets/locales/pl.json'; // Polish
import deTranslations from '@/assets/locales/de.json'; // German
import esTranslations from '@/assets/locales/es.json'; // Spanish
import frTranslations from '@/assets/locales/fr.json'; // French
import itTranslations from '@/assets/locales/it.json'; // Italian
import elTranslations from '@/assets/locales/el.json'; // Greek
import ukTranslations from '@/assets/locales/uk.json'; // Ukrainian

export const SUPPPORTED_LOCALES = ['en', 'ru', 'pl', 'de', 'es', 'fr', 'it', 'el', 'uk'];
export const TEXT_DICTIONARY = {
    en: enTranslations,
    ru: ruTranslations,
    pl: plTranslations,
    de: deTranslations,
    es: esTranslations,
    fr: frTranslations,
    it: itTranslations,
    el: elTranslations,
    uk: ukTranslations,
};
export const LOCATION_ELEMENT_ID = 'element-location-text';
export const QRID_ELEMENT_ID = 'element-qrid-text';
